import { Component, OnInit,ViewChild } from '@angular/core';
import { NavigationExtras, Router, ActivatedRoute, NavigationEnd } from '@angular/router';
import { StoreService } from 'src/app/services/store.service';
import { ToastService } from 'src/app/services/toast.service';
import { ActionSheetController } from '@ionic/angular';
import { AlertController } from '@ionic/angular';
import { Geolocation } from '@awesome-cordova-plugins/geolocation/ngx';
import { NavController } from '@ionic/angular';
import { IonInfiniteScroll } from '@ionic/angular';

@Component({
  selector: 'app-grocery-list',
  templateUrl: './grocery-list.page.html',
  styleUrls: ['./grocery-list.page.scss'],
})
export class GroceryListPage implements OnInit {
  @ViewChild(IonInfiniteScroll) infiniteScroll: IonInfiniteScroll;
  userId: any=localStorage.getItem('userId');
  productList: any = [];
  category: any = "";
  page_number: number = 1;
  limit = 500;
  currentUrl: any;
  previousUrl: any;
  isLoadData = false;
  searchParams: String;
  searchResultData: any = [];
  noDataImage: boolean = false;
  locationFlag: any = 0;
  //Location variable
  address: string;
  latitude: number;
  longitude: number;
  accuracy: number;
  subCategory: any;
  isLoading: boolean = false;
  productFound: boolean = false;
  pin: any;
  city = localStorage.getItem('city');
  isPromoActiveFlag: any;
  storeDetail: any;
  recommendflag: any;
  first: boolean;
  count: any;
  search: boolean=false;
  skipRole : any;
  filterO =1;
  a : any;
  discount: any = "0";
  price: any = "0-10000000";
  filterData : any;
  length : any;
  check : any=0;
  offset : any=0;
  storeId : any;
  constructor(private routerActivate: ActivatedRoute, private toast: ToastService, private router: Router, private authService: StoreService,  public actionSheetController: ActionSheetController, public alertController: AlertController, private geolocation: Geolocation,private navController : NavController
    )
   {
   

  }
  ngOnInit() {
    
    this.city=localStorage.getItem("city");
    // this.storeId=this.routerActivate.snapshot.params.storeId;
    this.category=this.routerActivate.snapshot.params.category;
    this.subCategory=this.routerActivate.snapshot.params.subCat;
    if(this.subCategory==0){
      this.subCategory=""
    }

    console.log("store detail",this.storeDetail)
    if(this.city!=null && this.city!='')
    {
      localStorage.setItem('city', this.city);
    }
    if(this.pin!=null && this.pin!='')
    {
      localStorage.setItem('pin', this.pin);
    }
   
    this.city = localStorage.getItem('city');
    if(this.city!=null)
    {
      this.locationFlag = 3;
    }
    this.pin = localStorage.getItem('pin')
    if(this.pin!=null)
    {
      this.locationFlag = 2;
    }
    this.searchResultData = "";
    this.listOfProduct()
  }
 
  listOfProduct(loaded=false,event?) {
    if(loaded){
      this.offset+=0;
    }
    this.isLoading = true;
    const promoListobj = {
      cat: this.category,
      subcat: this.subCategory,
      limit: this.limit,
      // storeid: this.storeId,
      city:this.city,
      offset : this.offset
    }
    console.log("promotion cat param", promoListobj)
    this.authService.getProduct(promoListobj).subscribe((data: any) => {
      this.isLoading = false;
      if (data.code == 0 && this.page_number == 1) {
        this.noDataImage = true
        
      } else if (data.code == 3 && this.page_number == 1) {
        this.noDataImage = true
       
      }
      else {
       
        for (let i = 0; i < data.length; i++) {
          
          this.productFound = true;
          this.count=0;
          for(let j=0;j<this.productList.length;j++)
          {
            if(this.productList[j].articleNumber==(data[i].articleNumber)){
             this.count++;
            }
          }
          if(this.count==0)
          {
            this.productList.push(data[i]);
          }
    
         // this.productList.push(data[i]);
        }
        if (loaded)
          event.target.complete();
       
        console.log("product detail API hit", this.productList)
        console.log("dataImage", this.noDataImage)
      }
      if(this.productList.length>0){
        this.check=0;
      }
      else{
        this.check=1;
        console.log("hekkkk")
      }

    }, (error: any) => {
    
    });
  }
 
  productDetail(productItem: any) {
    let qty = 1;
   
    let navigationParams: NavigationExtras = { state: { productId: productItem._id, promotionId: productItem.promotionId, productQty: qty, backPageFlag: { cat: this.category, subCat: this.subCategory, backPageFlagInfo: "G", isPromoActiveFlag: this.isPromoActiveFlag,storeDetail: this.storeDetail,city:this.city,pin:this.pin } } };
    this.router.navigate(['product-detail'], navigationParams)
  }

 

  goHome() {
    this.router.navigate(['/'])
  }
  goBack() {
    this.navController.pop();
  }
  
 

  fetchCatStoreTerm() {
      this.router.navigate(['/search-product']);
     }

  async basedOnSearchProduct() {
    const actionSheet = await this.actionSheetController.create({
      header: 'Accurate Search',
      cssClass: 'action-search-custom-class',
      buttons: [{
        text: 'Current Location',
        role: 'destructive',
        icon: 'locate-outline',
        handler: () => {
          localStorage.setItem('city', '');
          localStorage.setItem('pin', '');
          this.city=''
          this.pin=''
          this.locationFlag = 1;
          this.page_number = 1;
          this.productList = [];
          this.getGeolocation()
          
          console.log('Delete clicked');
        }
      }, {
        text: 'Zip Code',
        icon: 'pin-outline',
        handler: () => {
          this.locationFlag = 2;
          this.page_number = 1;
          this.enterSerachkeyword(this.locationFlag)
          console.log('Share clicked');
        }
      }, {
        text: 'City',
        icon: 'business-outline',
        handler: () => {
          this.locationFlag = 3;
          this.page_number = 1;
         // this.enterSerachkeyword(this.locationFlag)
         this.enterCityRadio(this.locationFlag)
          console.log('Play clicked');
        }
      }, {
        text: 'Shipping Address',
        icon: 'cart-outline',
        handler: () => {
          this.locationFlag = 4;
          this.page_number = 1;
          this.productList = [];
          this.productFound = false;
          this.noDataImage = false;
          this.listOfProduct()
          console.log('Favorite clicked');
        }
      }, {
        text: 'Cancel',
        icon: 'close',
        role: 'cancel',
        handler: () => {
          console.log('Cancel clicked');
        }
      }]
    });
    await actionSheet.present();

    const { role } = await actionSheet.onDidDismiss();
    //console.log('onDidDismiss resolved with role', role);
  }
  async enterSerachkeyword(flag: number) {
    const alert = await this.alertController.create({
      cssClass: 'my-custom-class',
      header: 'Search Keyword',
      inputs: [
        {
          name: 'searchKeyword',
          type: 'text',
          placeholder: 'Please Enter here'
        },
      ],
      buttons: [
        {
          text: 'Cancel',
          role: 'cancel',
          cssClass: 'secondary',
          handler: (blah) => {

            //  console.log('Confirm Cancel: blah');
          }
        }, {
          text: 'Okay',
          handler: (data) => {
            if (flag == 2) {
              //flag use for enter "pin" keyword
              this.productList = [];
              this.page_number = 1;
              this.pin = data.searchKeyword;
              this.city=null;
              localStorage.setItem('pin', data);
              localStorage.setItem('city', '');
              console.log('Confirm flag == 2');
              this.listOfProduct()
            }
            // else if (flag == 3) {
            //   //flag use for enter "city" keyword
            //   this.productList = [];
            //   this.page_number = 1;
            //   this.city = data.searchKeyword;
            //   console.log('Confirm flag == 3');
            //   this.listOfProduct(false, "", this.category, "", data.searchKeyword, flag, "", "", this.subCategory)
            //   //console.log('Confirm Okay', data.searchKeyword);
            //   // this.redeemcode(data.code, subOrder)
            // }
          }
        }
      ]
    });

    await alert.present();
  }
  ////City radio button added by Parul
  async enterCityRadio(flag: number) {
    const alert = await this.alertController.create({
      cssClass: 'my-custom-class',
      header: 'Select City',
      inputs: [
        {
          name: 'radio1',
          type: 'radio',
          label: 'Kanpur',
          value: 'Kanpur',
          // handler: () => {
          //   console.log('Radio 1 selected');
          // },
        },
        {
          name: 'radio1',
          type: 'radio',
          label: 'Lucknow',
          value: 'Lucknow',
          // handler: () => {
          //   console.log('Radio 1 selected');
          // },
        },
      ],
      buttons: [
        {
          text: 'Cancel',
          role: 'cancel',
          cssClass: 'secondary',
          handler: (blah) => {

            //  console.log('Confirm Cancel: blah');
          }
        }, {
          text: 'Okay',
          handler: (data) => {
           if (flag == 3) {
              //flag use for enter "city" keyword
              this.productList = [];
              this.page_number = 1;
              localStorage.setItem('city', data);
              this.city = data;
              this.pin=null;
              localStorage.setItem('pin','');
              this.locationFlag = 3;
              console.log('Confirm flag == 3',this.city);
              this.listOfProduct()
              //console.log('Confirm Okay', data.searchKeyword);
              // this.redeemcode(data.code, subOrder)
            }
          }
        }
      ]
    });

    await alert.present();
  }////
   async getGeolocation() {
    return new Promise((resolve, reject) => {
    console.log("you are in getGeolocation() function--")
    this.geolocation.getCurrentPosition({ enableHighAccuracy: true ,timeout:1000}).then((resp) => {
      this.latitude = resp.coords.latitude;
      this.longitude = resp.coords.longitude;
      this.accuracy = resp.coords.accuracy;
      console.log("Response from current lat long", resp.coords.latitude, resp.coords.longitude)
      if(this.latitude!=null && this.longitude!=null && this.city!=null && this.city!="")
      {
        this.locationFlag=3
        this.listOfProduct()
      }
      else if(this.latitude!=null && this.longitude!=null && this.pin!=null && this.pin!=""){
        this.locationFlag=2
      this.listOfProduct()
      }
      else
      {
        localStorage.setItem('city', '');
        localStorage.setItem('pin','');
        this.listOfProduct()
      }
      this.sendGioData(this.latitude, this.longitude);
      return resolve(resp.coords)
    }).catch((error) => {
      console.log('Error getting location in getGeolocation()' + JSON.stringify(error));
      // if((this.city==null || this.city=="") && (this.pin==null || this.pin==""))
      // {
      //   this.alertLocation();
      // }
      return resolve(false)
    });
  });
  }


  sendGioData(latitude, longitude) {
    console.log("Device latitude and logitude", latitude, longitude)
    const GeoDataobj = {
      userId: this.userId,
      geo: {
        latitude: latitude,
        longitude: longitude
      }
    }
    console.log("login sending from MAP page param", GeoDataobj)
    this.authService.sendGioData(GeoDataobj).subscribe((result: any) => {
      console.log("Response from Giolocation from map page", JSON.stringify(result))
    }, (error: any) => {
      this.toast.presentToast("there is error in gio location time time")
    });
  }
  ///Location access request

  ///Added by Parul for Add to wishlist

  Wishlist(item: any){
    let promoListobj = {
      productdetails: item,
      userId: this.userId,
      productId: item._id
    }
    // this.authService.addCartServices(APIS.addTocart,formdata,true)
    console.log("wishlist Request param ",promoListobj)
    this.authService.addToWishlist(promoListobj)
      .subscribe((result: any) => {
        //this.messanger.sendMsg(productObj)
        this.toast.presentToast("Product added in your Wishlist")
      }, (error: any) => {
      });
  }////

  //////Alert for current location added by parul

  async alertLocation() {
    const alert = await this.alertController.create({
      cssClass: 'my-custom-class',
      header: 'Alert!',
      message: 'Please turn on your current location',
      buttons: [
        {
          text: 'Cancel',
          role: 'cancel',
          cssClass: 'secondary',
          handler: (blah) => {
            console.log('Confirm Cancel: blah');
          }
        }, {
          text: 'Okay',
          handler: () => {
            console.log('Confirm Okay');
          }
        }
      ]
    });

    await alert.present();
  }

  filter(){
    this.filterO=this.filterO*(-1)
    console.log(this.filterO)
    if(this.filterO==1){
      this.a=20
    }
    else{
      this.a=125;
    }
  }
  //Added by Divyansh Sharma on 18-02-2022 (bug no.1015) apply filters for products
  filterSubmit() {
    let formData = {
      city: this.city,
      cat: this.category,
      subcat: this.subCategory,
      limit: this.limit,
      offset: 0
    }

    if (this.price != "")
      formData['price'] = this.price.split("-");

    if (this.discount != 0)
      formData['discount'] = this.discount;

    this.authService.getProduct(formData).subscribe(res => {
      this.filterData = res;
      this.productList = this.filterData;
      this.length = res.length;
      this.filterO = 1;
      this.a = 20;
      if (this.productList.length > 0) {
        this.check = 0;
      } else {
        this.check = 1;
      }
    })
  }

  notifications(){
    this.router.navigate(['/wishlist']);
  }
  home(){
    this.router.navigate(['/']).then(()=>{
      window.location.reload()
    })
  }
  


}
